import { createUseStyles } from "react-jss";

const useStyles = createUseStyles(theme => ({
  "@keyframes fadein": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  container: {
    height: "90%",
    maxWidth: 800,
    background: theme.colorDarkGrey,
    position: "fixed",
    zIndex: 1001,
    boxShadow: "2px 0px 16px rgba(0, 0, 0, 0.27)",
    "border-radius": 3,
    alignSelf: "center",
    top: "5%",
    color: "white",
    overflow: "auto",
    animation: "$fadein ease 0.2s",
    padding: 16,
    "& p": {
      fontSize: 18,
      fontWeight: "500",
    },
  },
  backgroundHider: {
    width: "100%",
    height: "100%",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 10,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
  },
  imageStep: {
    width: "100%",
    height: "auto",
  }
}));

const GetVideoTutorial = ({ onClose }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.container}>
        <h2>Get video url from Vimeo</h2>
        <p>1, Open your video detail on video.com. The privacy of the video should be "public"</p>
        <img
          src={`${window.location.origin}/assets/vimeo-step-1.png`}
          className={classes.imageStep}
          alt="step-1"
        />
        <p>2, Press "Embed" button</p>
        <img
          src={`${window.location.origin}/assets/vimeo-step-2.png`}
          className={classes.imageStep}
          alt="step-2"
        />
        <p>3, Copy the URL inside the snippet</p>
        <img
          src={`${window.location.origin}/assets/vimeo-step-3.png`}
          className={classes.imageStep}
          alt="step-3"
        />
        <p>*** The URL should be like these:</p>
        <p>{`https://player.vimeo.com/video/931990120?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`}</p>
        <p>https://vimeo.com/931990120/58479</p>
      </div>
      <div className={classes.backgroundHider} onClick={onClose} />
    </>
  );
};

export default GetVideoTutorial;
